import { createSelector } from "reselect";

import { RootState } from "app/store/rootReducer";

export const stateSelector = (state: RootState) => state.axesSlice;

export const axesSelector = createSelector(stateSelector, (state) => state.axes);
export const axesLoadingSelector = createSelector(stateSelector, (state) => state.isLoading);
export const axesInvalidateKeySelector = createSelector(stateSelector, (state) => state.invalidateKey);
